import { render } from "./ButtonsForOfferView.vue?vue&type=template&id=5ca36bf9&scoped=true&ts=true"
import script from "./ButtonsForOfferView.vue?vue&type=script&lang=ts"
export * from "./ButtonsForOfferView.vue?vue&type=script&lang=ts"

import "./ButtonsForOfferView.vue?vue&type=style&index=0&id=5ca36bf9&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca36bf9"],['__file',"src/components/ButtonsForOfferView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ca36bf9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ca36bf9', __exports__)) {
    console.log('reload')
    api.reload('5ca36bf9', __exports__)
  }
  
  module.hot.accept("./ButtonsForOfferView.vue?vue&type=template&id=5ca36bf9&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('5ca36bf9', render)
  })

}


export default __exports__